import * as React from 'react';
import * as ReactDOM from 'react-dom';

import Home from '@containers/Home';
import Portfolio from '@containers/Portfolio';
import PortfolioItem from '@containers/Portfolio/Item';
import Blog from '@containers/Blog';
import BlogItem from '@containers/Blog/Item';
import Transition from '@containers/Transition';
import Contact from '@containers/Contact';
import Skills from '@containers/Skills';
import Privacy from '@components/Privacy';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import reducers from './reducers';
import { BrowserRouter as Router, Route, Switch, RouteComponentProps } from 'react-router-dom';
import { TransitionGroup } from "react-transition-group";
import w from '@store/window';
import initialState from '@store/initialState';
import ReactGA from 'react-ga'
import GAListener from '@utils/analytics/GAListener';
import 'normalize.css';
import './index.scss';

const store = createStore(reducers, initialState, w.__REDUX_DEVTOOLS_EXTENSION__ && w.__REDUX_DEVTOOLS_EXTENSION__());

ReactGA.initialize('UA-137455925-1');

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <Route
                path="/"
                render={({location}: RouteComponentProps) => (
                    <TransitionGroup>
                        <Transition
                            key={location.key}
                            timeout={{ enter: 1000, exit: 500 }}
                            unmountOnExit
                        >
                            <GAListener>
                                <Switch location={location}>
                                    <Route exact path="/portfolio"component={Portfolio} />
                                    <Route exact path="/portfolio/:item"component={PortfolioItem} />
                                    <Route exact path="/blog"component={Blog} />
                                    <Route exact path="/blog/:item"component={BlogItem} />
                                    <Route exact path="/privacy"component={Privacy} />
                                    <Route exact path="/skills"component={Skills} />
                                    <Route exact path="/contact"component={Contact} />
                                    <Route exact path="/" component={Home} />
                                </Switch>
                            </GAListener>
                        </Transition>
                    </TransitionGroup>
                )}>
            </Route>
        </Router>
    </Provider>,
    document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx